import DateTime from '~/lib/NewDateTime';

function objFromStr(timeStr, timezone) {
    let timeObj = null;
    if (timeStr instanceof Date) {
        // in RescheduleButton.jsx the date is passed in as a JS obj
        return (timeObj = DateTime.fromJsDate(timeStr));
    } else {
        timeObj = DateTime.fromString(timeStr);
    }

    return timeObj.updateTimezone(timezone);
}

export function clientFormatDateLong(timeStr, timezone) {
    const dateObj = objFromStr(timeStr, timezone);
    return dateObj.formatDateLong();
}

export function clientFormatDateTime(timeStr, timezone) {
    const dateObj = objFromStr(timeStr, timezone);
    return dateObj.formatDate() + ' ' + dateObj.formatTime();
}

export function clientFormatDateTimeLong(timeStr, timezone) {
    const dateObj = objFromStr(timeStr, timezone);
    return dateObj.formatDateTimeLong();
}

export function clientFormatTime(timeStr, timezone) {
    const dateObj = objFromStr(timeStr, timezone);
    return dateObj.formatTime();
}
